import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import shouldUse3SPeopleSuggestions from 'owa-substrate-people-suggestions/lib/utils/shouldUse3SPeopleSuggestions';

export default function removeDuplicateResultsFromResponse(
    currentEmailAddresses: Map<string, FindRecipientPersonaType>,
    serverResult: FindPeopleResponseMessage | SubstrateSearchSuggestionsResponse
): void {
    if (shouldUse3SPeopleSuggestions()) {
        removeDuplicate3SResults(
            currentEmailAddresses,
            serverResult as SubstrateSearchSuggestionsResponse
        );
    } else {
        removeDuplicateFindPeopleResults(
            currentEmailAddresses,
            serverResult as FindPeopleResponseMessage
        );
    }
}

function removeDuplicate3SResults(
    currentEmailAddresses: Map<string, FindRecipientPersonaType>,
    resp: SubstrateSearchSuggestionsResponse
) {
    for (const group of resp.Groups) {
        if (group.Type === 'People') {
            let filteredSuggestions = group.Suggestions.filter(value => {
                return (
                    currentEmailAddresses[value.EmailAddresses ? value.EmailAddresses[0] : ''] ==
                    null
                );
            });
            group.Suggestions = filteredSuggestions;
            break;
        }
    }
}

function removeDuplicateFindPeopleResults(
    currentEmailAddresses: Map<string, FindRecipientPersonaType>,
    resp: FindPeopleResponseMessage
) {
    let filteredSuggestions = resp.ResultSet.filter(value => {
        return (
            currentEmailAddresses[value.EmailAddress ? value.EmailAddress.EmailAddress : ''] == null
        );
    });
    resp.ResultSet = filteredSuggestions;
}
